<app-last-mile-table
  [dataSource]="dataSource"
  [lastMileState]="LastMileStateEnum.Pending"
  [warehouses]="warehouses"
  [businesses]="businesses"
  (tableActionTaken)="handleTableAction($event)"
></app-last-mile-table>
